import React, { Component } from "react";
import { Form, Icon, Input, Button, Tooltip, Radio,DatePicker  } from "antd";
import { connect } from "react-redux";
import * as loginActions from "../../actions";
import moment from "moment";
import "./step1.css";

class StepOne extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkPhoneNumberLength = (rule, value, callback) => {
    if (value && value.length !== 10) {
      callback("Phone Nmuber must be 10 Digits");
    } else {
      callback();
    }
  };

  render() {
    const { form, profile } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const { email, personalEmail, phoneNumber, gender, fullName,dob } = profile;
    const onValidateForm = e => {
      e.preventDefault();
      validateFields((err, values) => {
       
        if (!err) {
          // 
          values.dob = values.dob.format(
            "MMMM Do YYYY"
          );
          this.props.stepOneSubmit(values);
        }
      });
      // this.props.login({});
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      }
    };

    return (
      <>
        <h2 className="steponeHeading">Personal Details</h2>
        <p className="steponeDisc">Please add your personal details</p>
        <Form {...formItemLayout}>
          <Form.Item label="College Email ID" className="formsteponeinout">
            {getFieldDecorator("primaryEmail", {
              initialValue: email,
              rules: [
                { required: true, message: "Please input your username!" }
              ]
            })(
              <Input
                prefix={<Icon type="user" />}
                placeholder="Password"
                size="large"
                disabled
              />
            )}
          </Form.Item>
          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                Secondary Email&nbsp;
                <Tooltip title="Your personal email id (Gmail..etc)?">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("personalEmail", {
              initialValue: personalEmail,
              rules: [
                {
                  type: "email",
                  message: "The input is not valid E-mail!"
                },
                {
                  required: true,
                  message:
                    "Please input your personal email id! If you dont have one. keep same college email id here"
                }
              ]
            })(
              <Input
                prefix={
                  <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="text"
                placeholder="Email"
                size="large"
              />
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                Full Name&nbsp;
                <Tooltip title="Your Full Name (As per college records)">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("fullName", {
              initialValue: fullName,
              rules: [
                { required: true, message: "Please input your Full Name" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="text"
                placeholder="Full Name"
                size="large"
              />
            )}
          </Form.Item>

          <Form.Item className="formsteponeinout" label={<span>Gender</span>}>
            {getFieldDecorator("gender", {
              initialValue: gender,
              rules: [{ required: true, message: "Select your gender" }]
            })(
              <Radio.Group>
                <Radio value="male">Male</Radio>
                <Radio value="female">Female</Radio>
              </Radio.Group>
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={<span>Phone Number</span>}
          >
            {getFieldDecorator("phoneNumber", {
              initialValue: phoneNumber,
              rules: [
                { required: true, message: "Please input your phone number!" },
                {
                  validator: this.checkPhoneNumberLength
                }
              ]
            })(
              <Input
                addonBefore={<span>+91</span>}
                type="text"
                placeholder="Phone number"
                size="large"
              />
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={<span>Date Of Birth</span>}
          >
            {getFieldDecorator("dob", {
              initialValue: dob
              ? moment(dob, "MMMM Do YYYY")
              : undefined,
              rules: [
                { required: true, message: "Please input your Date Of Birth (YYYY-MM-DD)" }
              ]
            })(
              <DatePicker  placeholder="YYYY-MM-DD"  size="large" />
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" onClick={onValidateForm} htmlType="submit">
              Next
            </Button>
          </Form.Item>
        </Form>
      </>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    profile: state.firebase.profile
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepOneSubmit: formValue => {
    dispatch(loginActions.stepOneSubmit(formValue, props.history));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(StepOne));
